/* ============================================================
   sm-hurda-flow.js

   Tveir gallar í kaupferli hurðaskiltanna, mældir 2026-09-22.

   ------------------------------------------------------------
   1. STAÐFESTINGIN BIRTIST ALDREI
   ------------------------------------------------------------
   Eigandinn: "engin staðfesting þegar það er búið að bæta í körfu".

   Borðinn er til, textinn er réttur og hann mælist 372px hár. Hann
   er bara teiknaður FYRIR NEÐAN gluggann:

     .cart-sheet      { transform: translate(-50%, 100%) }   falin
     .cart-sheet.open { transform: translate(-50%) }          sýnileg

   Klasinn .open kemur aldrei. Ástæðan er í sm-main.js:

     document.addEventListener("submit", function (e) {
       var form = e.target.closest('form[action*="/cart/add"]');
       if (form) { ... openSheet(...) }
     });

   Borðinn opnast sem sagt AÐEINS ef formið ber action sem inniheldur
   /cart/add. Stillisformið hefur `action = null` og bætir í körfu með
   eigin fetch í sm-hurda-config.js. Skilyrðið bregst og openSheet
   keyrir aldrei. Mælt: aria-hidden stóð enn á "true" eftir að varan
   var komin í körfuna.

   Þetta er NÁKVÆMLEGA sama orsök og þegar greiðslumerki traustappsins
   vantaði á þessa einu síðu: það app leitar líka að
   form[action*="/cart/add"].

   AF HVERJU EKKI BARA SETJA action Á FORMIÐ: þá myndi submit-hlustari
   sm-main.js grípa það, kalla preventDefault og senda SÍNA eigin
   /cart/add beiðni, ofan á þá sem sm-hurda-config.js sendir hvort eð
   er. Varan færi tvisvar í körfuna. Þess vegna er hlustað á beiðnina
   sjálfa í staðinn.

   ------------------------------------------------------------
   2. SKREF 1 VARÐ GRÆNT ÁN ÞESS AÐ NÖFN VÆRU SKRIFUÐ
   ------------------------------------------------------------
   Eigandinn: "þarna er grænt í nöfn en hef ekki skrifað nein nöfn".

   sm-hurda-steps-extra.js merkir skref eftir STÖÐU en aldrei eftir
   innihaldi:

     function mark(root, n) {
       items(root).forEach(function (it, i) {
         it.classList.toggle("active", i + 1 === n);
         it.classList.toggle("done",   i + 1 < n);
       });
     }

   Um leið og smellt er á efni eða stærð verða öll skref á undan græn.
   Síðan segir viðskiptavininum að hann sé búinn að skrifa nöfnin, og
   svo stöðvar sm-hurda-guard.js körfuna án þess að hann skilji hvers
   vegna. Tvö kerfi með sitt hvora skoðun á sama hlut.

   Skref 2, 3 og 4 hafa öll sjálfgefið val, svo þau eru raunverulega
   frágengin um leið. Skref 1 er það eina sem getur verið tómt, og það
   er eina skrefið sem er leiðrétt hér.
   ============================================================ */
(function () {
  var root = document.querySelector('[data-hurda]');
  if (!root) return;

  /* ---------- 1. Staðfestingarborðinn ---------- */
  var sheet = document.querySelector('[data-sm-cart-sheet]');
  var scrim = document.querySelector('[data-sm-sheet-scrim]');

  function kr(aurar) {
    return String(Math.round(aurar / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' kr.';
  }

  /* Sérsmíðað skilti hefur ekkert vit í variant_title, þar stendur
     "Default Title". Eigindin sem viðskiptavinurinn valdi segja honum
     miklu meira, svo þau eru dregin saman í staðinn. */
  function lysing(item) {
    var p = item && item.properties;
    if (!p) return item && item.variant_title ? item.variant_title : '';
    var radir = [];
    ['Efni og litur', 'Stærð', 'Leturgerð'].forEach(function (k) {
      if (p[k]) radir.push(p[k]);
    });
    return radir.join(' · ');
  }

  function fylla(item, cart) {
    var n = sheet.querySelector('[data-sm-sheet-name]');
    var s = sheet.querySelector('[data-sm-sheet-spec]');
    var v = sheet.querySelector('[data-sm-sheet-price]');
    var t = sheet.querySelector('[data-sm-sheet-thumb]');
    var c = document.querySelector('[data-sm-cart-count]');
    var titill = item.product_title || item.title || '';

    if (n) n.textContent = titill;
    if (s) s.textContent = lysing(item);
    if (v) v.textContent = kr(item.final_price || item.price || 0);
    if (c && cart) c.textContent = cart.item_count;
    if (t) {
      var mynd = item.image || (item.featured_image && item.featured_image.url);
      t.innerHTML = mynd
        ? '<img src="' + mynd + '" alt="" style="width:100%;height:100%;object-fit:cover;border-radius:8px">'
        : '<span class="cart-sheet-thumb-inner">' + titill + '</span>';
    }
  }

  function opna() {
    sheet.classList.add('open');
    sheet.setAttribute('aria-hidden', 'false');
    if (scrim) scrim.classList.add('show');
  }

  if (sheet && window.fetch) {
    var upphaflegt = window.fetch;
    window.fetch = function (input, init) {
      var slod = typeof input === 'string' ? input : (input && input.url) || '';
      var svar = upphaflegt.apply(this, arguments);
      if (/\/cart\/add/.test(slod)) {
        svar.then(function (res) {
          if (!res || !res.ok) return;
          /* Hafi sm-main.js þegar opnað borðann er ekkert að gera.
             Á venjulegum vörusíðum ber formið action og sá hlustari
             virkar eins og til stóð. */
          if (sheet.classList.contains('open')) return;
          return res.clone().json().then(function (item) {
            /* Aðeins raunveruleg körfulína (hún ber key) opnar borðann.
               Villusvar, eða síða sem tilvísun endaði á, gerir það ekki. */
            if (!item || !item.key) return;
            return upphaflegt('/cart.js', { headers: { Accept: 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (cart) { fylla(item, cart); opna(); });
          });
        })['catch'](function () { /* þögn: staðfesting má aldrei fella körfuna */ });
      }
      return svar;
    };
  }

  /* Lína með framleiðsluskrá fer í körfu um SMFram.senda (XMLHttpRequest, ekki fetch), svo fetch-hlustunin
     hér að ofan sér hana ekki. sm-hurda-config.js sendir sm:hurda-karfa þegar línan er komin; sé borðinn
     þá ekki opinn er nýjasta körfulínan (fremst í /cart.js) sýnd, eins og hér að ofan. */
  if (sheet) {
    document.addEventListener('sm:hurda-karfa', function (e) {
      if (!e || !e.detail || !e.detail.ok) return;
      setTimeout(function () {
        if (sheet.classList.contains('open')) return;
        (upphaflegt || window.fetch).call(window, '/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var item = cart && cart.items && cart.items[0];
            if (!item || !item.key || sheet.classList.contains('open')) return;
            fylla(item, cart); opna();
          })['catch'](function () { /* þögn: staðfesting má aldrei fella körfuna */ });
      }, 300);
    });
  }

  /* ---------- 2. Skref 1 segir satt ---------- */
  var stika = root.querySelector('.config-stepper');
  var reitur = root.querySelector('textarea[data-names]');

  function satt() {
    if (!stika || !reitur) return;
    var fyrsta = stika.querySelector('.stepper-item');
    if (!fyrsta) return;
    var tomur = reitur.value.replace(/\s+/g, '') === '';
    /* Aðeins fjarlægt ef klasinn er til staðar, annars kveikir
       classList.remove nýja breytingu og fylgjarinn fer í hring. */
    if (tomur && fyrsta.classList.contains('done')) {
      fyrsta.classList.remove('done');
    }
  }

  if (stika && reitur && window.MutationObserver) {
    new MutationObserver(satt).observe(stika, {
      attributes: true, subtree: true, attributeFilter: ['class']
    });
    reitur.addEventListener('input', satt);
    satt();
  }
})();
